import { combineReducers } from "redux";
import { initialReducer } from "./initialReducer";

export const rootReducer = combineReducers({initialReducer});